<template>
  <div>
    <TemplateForm
      :show="showTemplateForm"
      :familias="familias"
      :initialEditModel="template"
      :form_title="form_title"
      @save="handleSave"
      @cancel="handleCancel"
      ref="capaFormRef"
    />
    <GenericDataTable
      v-if="validPermission('O0006')"
      ref="dataTableRef"
      @row-click="null"
      @boolean-toggle="handleBooleanToggle"
      @action="handleTableAction"
      :tableData="templateData"
      :api-url="null"
      :useServerSide="false"
      :columns="templateColumns"
      :show_close_btn="false"
      table_title="Templates"
    >
      <template #left-actions>
        <button
          class="action-btn filter-btn"
          @click="showFilter = !showFilter"
          title="Filtros"
        >
          <i class="fa-solid fa-filter"></i>
        </button>
        <button
          class="action-btn filter-btn"
          @click="triggerAction({ action: 'create_template' })"
          title="Adicionar"
        >
          <i class="fa-solid fa-circle-plus fa-xl"></i>
        </button>
      </template>
    </GenericDataTable>
  </div>
</template>
<script>
import { toast } from "vue3-toastify";
import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
import TemplateForm from "@/components/capa_template/template/templateForm.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import { auto } from "@popperjs/core";
export default {
  mixins: [permissionMixin],
  name: "app-template",
  components: {
    TemplateForm,
    GenericDataTable,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      templateData: [],
      familias: [],
      editId: null, // If editing, set the id here
      showTemplateForm: false,
      template: {},
      form_title: "",
      templateColumns: [
        {
          key: "familia.nome",
          label: "Família",
          sortable: true,
          type: "string",
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
          type: "string",
        },
        {
          key: "created_at",
          label: "Data Criação",
          sortable: false,
          type: "datetime",
        },
        {
          key: "status",
          label: "Estado",
          sortable: true,
          type: "badge",
        },

        {
          key: "",
          label: "Ações",
          sortable: false,
          type: "actions",
          actions: [
            // Edit
            {
              type: "edit",
              icon: "fa-solid fa-pen-to-square",
              class:
                "action-icon-btn text-blue-500 bg-blue-100/20 hover:bg-blue-100",
              title: "Editar Template",
            },
            {
              type: "delete",
              icon: "fa-solid fa-trash",
              class:
                "action-icon-btn text-red-500 bg-red-100/20 hover:bg-red-100",
              title: "Eliminar Template",
              showIf: (item) => {
                return item.familia_id != "0"; // Only show delete if it's not the default template
              },
            },
            // View file
            {
              type: "viewFile",
              icon: "fa-solid fa-image",
              class:
                "action-icon-btn text-red-500 bg-red-100/20 hover:bg-red-100",
              title: "Ver Template",
              showIf: (item) => {
                return !!item.capa_path;
              },
            },
          ],
        },
      ],
    };
  },
  methods: {
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error(
          "Error creating data:",
          error.response?.data?.message || error,
        );
        this.lastError = error.response?.data?.message || error;
        return null;
      }
    },
    async update(data, url) {
      try {
        const res = await axios.put(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error updating data:", error.response.data.message);
        this.lastError = error.response?.data?.message || error;
        return null;
      }
    },
    async fetchTemplateData() {
      try {
        const res = await this.select(`${this.baseURL}/api/v1/template/`);
        this.templateData = res;
        console.log("Fetched template data:", this.templateData);
      } catch (error) {
        console.error("Error fetching template data:", error);
      }
    },

    handleTableAction({ type, item }) {
      console.log("Table action:", type, item);
      if (type === "edit") {
        this.select_template(item);
        this.form_title = "Editar Template";
      } else if (type === "delete") {
        this.handleDelete(item);
      }
      // if (action === "edit") {
      //   this.select_template(row);
      // } else if (action === "viewArtigos") {
      //   // Handle view articles action
      //   this.$router.push({ name: 'EntradaArtigos', params: { entradaId: row.id } });
      // }
    },

    triggerAction(action) {
      if (action.action === "create_template") {
        this.showTemplateForm = true;
        this.template = {};
        this.form_title = "Criar Template";
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      }
    },
    select_template(row) {
      this.select(`${this.baseURL}/api/v1/template/${row.id}/`).then((data) => {
        this.template = data;
        this.showTemplateForm = true;
        this.form_title = "Editar Template";
        this.editId = row.id;
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      });
    },
    async handleSave(formModel) {
      // 1. Validation: Clean the HTML and check if it's effectively empty
      // This removes <p></p>, <br>, and spaces to see if there is actual content
      const contentCheck = formModel.template_text
        ? formModel.template_text.replace(/<[^>]*>/g, "").trim()
        : "";

      if (!contentCheck || contentCheck === "") {
        toast.warning("O conteúdo do template não pode estar vazio.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        return; // Stop the execution here
      }

      const dataToSave = { ...formModel };

      if (this.editId) {
        // Update Logic...
        const url = `${this.baseURL}/api/v1/template/${this.editId}/`;
        const result = await this.update(dataToSave, url);
        if (result) {
          toast.success("Template atualizado com sucesso!");
          this.closeForm(); // Helper to reset states
          await this.fetchTemplateData();
        } else {
          this.showErrorToast();
        }
      } else {
        // Create Logic...
        const url = `${this.baseURL}/api/v1/template/`;
        const result = await this.create(dataToSave, url);
        if (result) {
          toast.success("Template criado com sucesso!");
          this.closeForm();
          await this.fetchTemplateData();
        } else {
          this.showErrorToast();
        }
      }
    },

    closeForm() {
      this.showTemplateForm = false;
      this.editId = null;
      this.template = {};
    },
    handleCancel() {
      this.showTemplateForm = false;
    },
    showErrorToast(customMessage) {
      const message =
        customMessage || this.lastError || "Ocorreu um erro inesperado.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    },
    async handleDelete(item) {
      try {
        await axios.delete(`${this.baseURL}/api/v1/template/${item.id}/`);
        toast("Template eliminada com sucesso!", { type: "success" });
        this.fetchTemplateData();
      } catch (error) {
        console.error("Erro ao eliminar template:", error);
        toast.error("Erro ao eliminar template. Tente novamente.");
      }
    },
  },
  created() {
    this.fetchTemplateData();
    this.select(this.baseURL + "/api/v1/familia/").then((data) => {
      this.familias = data;
    });
  },
};
</script>
